import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { TypeStyle } from '../TypeStyle';
const BreadcrumbLink = styled.a `
  text-decoration: underline;
  text-decoration-thickness: 0.5px;
  text-underline-offset: 1.5px;
  color: ${o => o.theme.color.text.tertiary.on.background};
  &:hover {
    color: ${o => o.theme.color.text.secondary.on.background};
  }
`;
const BreadcrumbsWrapper = styled.ol `
  display: flex;
  flex-wrap: wrap;
`;
const BreadcrumbsTextLi = styled.li `
  ${TypeStyle.css.headlineMicro};
  display: flex;
  white-space: nowrap;
`;
export const Breadcrumbs = ({ children, ...rest }) => {
    return (_jsx("nav", { ...rest, children: _jsx(BreadcrumbsWrapper, { children: children }) }));
};
export const Breadcrumb = ({ as, children, currentPage = false, ...props }) => {
    return (_jsxs(BreadcrumbsTextLi, { children: [_jsx(BreadcrumbLink, { forwardedAs: as, ...props, "aria-current": currentPage ? 'page' : undefined, "$currentPage": currentPage, tabIndex: 0, children: children }), `\u00A0${!currentPage ? '/\u00A0' : ''}`] }));
};
//# sourceMappingURL=Breadcrumbs.js.map